import CrudPage from "@/components/app/CrudPage";
import { formatTL, formatDate } from "@/lib/api";

export default function PersonnelPage() {
  return (
    <CrudPage
      title="Personel"
      subtitle="Ofis personeli ve diğer çalışanların maaş kayıtları."
      endpoint="/personnel"
      testidPrefix="personnel"
      fields={[
        { key: "name", label: "Ad Soyad", type: "text", required: true },
        { key: "role", label: "Görev / Ünvan", type: "text" },
        { key: "department", label: "Departman", type: "text" },
        { key: "monthly_salary", label: "Aylık Maaş (₺)", type: "number" },
        { key: "hire_date", label: "İşe Başlama", type: "date" },
        { key: "phone", label: "Telefon", type: "text" },
      ]}
      columns={[
        { key: "name", label: "Ad Soyad" },
        { key: "role", label: "Görev" },
        { key: "department", label: "Departman" },
        { key: "monthly_salary", label: "Maaş", align: "right", render: (r) => formatTL(r.monthly_salary) },
        { key: "hire_date", label: "İşe Başlama", render: (r) => formatDate(r.hire_date) },
      ]}
    />
  );
}
